import {
    Icon,
    IconButton,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tooltip,
    Tr
} from '@chakra-ui/react'
import { format } from 'date-fns'
import parseISO from 'date-fns/parseISO'
import { RiDeleteBin6Line, RiPencilLine } from 'react-icons/ri'
import { Product } from '../../Interfaces/products'

interface Props {
  products: Product[]
  handleAction: (product: any) => void
  isDisabled?: boolean
}

export function List({ products, handleAction, isDisabled = false }: Props) {
  return (
    <>
      <Table>
        <Thead>
          <Tr>
            <Th>Nome</Th>
            <Th>Quantidade</Th>
            <Th>Cor</Th>
            <Th>Entrega</Th>
            <Th>Etapa</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {products?.map((product) => {
            return (
              <Tr key={product.id}>
                <Td>{product.description}</Td>

                <Td>{product.amount}</Td>
                <Td>{product.ink_color.name}</Td>
                <Td>{format(parseISO(product.delivery_date), 'dd/MM/yyyy')}</Td>
                <Td>{product.step}</Td>
                <Td display="grid" gridGap="2" gridTemplateColumns="1fr 1fr 1fr">
                  <Tooltip label="Editar" placement="top">
                    <IconButton
                      onClick={() => handleAction(product)}
                      size="md"
                      fontSize="sm"
                      colorScheme="purple"
                      aria-label="Editar"
                      icon={<Icon as={RiPencilLine} />}
                      isDisabled={isDisabled}
                    />
                  </Tooltip>
                  <Tooltip label="Remover" placement="top">
                    <IconButton
                      onClick={() => handleAction({ ...product, deleted: true })}
                      size="md"
                      fontSize="sm"
                      colorScheme="red"
                      aria-label="Remover"
                      icon={<Icon as={RiDeleteBin6Line} />}
                      isDisabled={isDisabled}
                    />
                  </Tooltip>
                </Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </>
  )
}
